// src/components/charts/DailyTransactionChart.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend,
} from 'recharts';

const DailyTransactionChart = ({ month }: { month: string }) => {
  const [data, setData] = useState([]);
  const API = process.env.REACT_APP_API_URL;

  const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    };
  };

  useEffect(() => {
    axios
      .get(`${API}/analytics/daily-transactions?month=${month}`, getAuthHeader())
      .then((res) => setData(res.data))
      .catch((err) => console.error('❌ Failed to fetch daily transactions', err));
  }, [month]);

  // Format label menjadi DD/MM/YYYY
  const formatDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tickFormatter={formatDate}
          tick={{ fontSize: 13 }} // ✅ kecilkan font label
        />
        <YAxis tickFormatter={(v: number) => `${v / 1_000_000}M`} 
		  tick={{ fontSize: 13 }}
		/>
        <Tooltip
          formatter={(value: number) => new Intl.NumberFormat().format(value)}
          labelFormatter={formatDate}
        />
        <Legend />
        <Line type="monotone" dataKey="value" stroke="#36a3f7" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default DailyTransactionChart;
